$(document).on('click', '[data-toggle=count-items]', function () {
	let $self = $(this),
		sign = $self.data('sign'),
		$container = $self.closest('.count-items'),
		$input = $container.find('input[name=cnt]'),
		cnt = $input.val() || 1;

	if (sign === 'minus') {
		if (cnt > 1) {
			cnt--;
		}
	} else {
		cnt++;
	}

	$input.val(cnt).trigger('change');

	return false;
});